// Central place to resolve the backend base URL.
// Production: /runtime-config.js (generated at container start from env vars).
// Development: optional public/runtime-config.js or CRA .env build-time vars.

import { getRuntimeEnv } from "@/lib/runtimeConfig";

const truthy = (value) => {
  const flag = String(value ?? "").trim().toLowerCase();
  return flag === "true" || flag === "1" || flag === "yes";
};

export function getBackendUrl() {
  // Docker / Easypanel: nginx proxies /api → backend when same-origin mode is enabled.
  if (truthy(getRuntimeEnv("REACT_APP_API_SAME_ORIGIN", "true")) && typeof window !== "undefined") {
    return window.location.origin;
  }

  const raw = getRuntimeEnv("REACT_APP_BACKEND_URL", "http://localhost:8002");
  if (typeof window === "undefined") return raw.replace(/\/$/, "");

  // If the app is opened via a non-localhost hostname (LAN IP / DNS),
  // and the backend URL points to localhost/127.0.0.1, rewrite the hostname
  // so API calls go to the same machine serving the frontend.
  try {
    const u = new URL(raw);
    const pageHost = window.location.hostname;
    const isBackendLocal = u.hostname === "localhost" || u.hostname === "127.0.0.1";
    const isPageLocal = pageHost === "localhost" || pageHost === "127.0.0.1";

    if (isBackendLocal && !isPageLocal && pageHost) {
      u.hostname = pageHost;
      return u.toString().replace(/\/$/, "");
    }
  } catch {
    // ignore invalid URL
  }

  return raw.replace(/\/$/, "");
}

export function getBackendOrigin() {
  try {
    return new URL(getBackendUrl()).origin;
  } catch {
    return getBackendUrl();
  }
}
